import { ENTER, SPACE, ENTER_KEY_NAME, SPACE_KEY_NAME } from './key-codes';
import { curry } from 'lodash';
import stopPropagation from './stop-propagation';
import preventDefault from './prevent-default';

/**
 * Helper functions that will allow us to handle the keypress events to make our components accessible to screen readers
 * @returns {boolean}
 */
function isKeycode(keyCode, keyName, e) {
    const isValid = e.keyCode === keyCode || e.key === keyName;

    if (isValid) {
        stopPropagation(e);
        preventDefault(e);
    }

    return isValid;
};

/**
 * True if enter was pressed
 */
export const enter = curry(isKeycode)(ENTER, ENTER_KEY_NAME);
/**
 * True if space was pressed
 */
export const space = curry(isKeycode)(SPACE, SPACE_KEY_NAME);

/**
 * True if space or enter was pressed pressed
 */
export const all = (e) => [enter, space].some(f => f(e));




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/handle-accessible-key-events.js